import React, { useMemo } from "react";
import { appealRequestForm } from "../../../shared/formObjects/application/appealRequestForm";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { useGlobalContext } from "../../../shared/GlobalContext";

export default function AppealRequestComponent({ disabled, data, showBack = false }: any) {
  const {
    application: { nextApplicationId, hasAppeal },
    applicationBase,
    id,
  } = useApplicationContext();

  const {
    accountInfo: { isDepartment, isKindergarten },
    addLoadingUrl,
    removeLoadedUrl,
  } = useGlobalContext();

  const api = useApiClient("AppealRequestCurrent");

  const context = useMemo(() => {
    let redirectPath = "";

    if (isDepartment) {
      redirectPath = "/department/applications/";
    } else if (isKindergarten) {
      redirectPath = "/kindergarten/pendingApplications/";
    } else {
      redirectPath = "/applications/ApplicationBaseCurrent/";
    }

    return {
      hasAppeal,
      discriminator: applicationBase.discriminator,
      redirectUrl: redirectPath + nextApplicationId,
    };
  }, []);

  return (
    <>
      {applicationBase.isFinalised && (
        <BaseApplicationComponent
          formBody={appealRequestForm}
          headerLabel="Appeal Request"
          editPath="appealRequest"
          apiClient={api}
          disabled={disabled || hasAppeal}
          formContext={context}
          data={data}
          showBack={showBack}
          showEdit={disabled && !hasAppeal}
          id={id}
          saveSuccessCB={async () => {
            addLoadingUrl("UserLinkLogic");
            await api.forceRefreshToken();
            removeLoadedUrl("UserLinkLogic");
          }}
        />
      )}
    </>
  );
}
